var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { translate } from '@utils/i18n';
import Brushaway from '../../../../components/Brushaway';
import TextInput from '@components/TextInput/TextInput';
import { SelectInput } from '@ui/molecules/inputs/form/SelectInput/SelectInput';
import { namespace } from './constants';
function BackFlowTypeDetail({ backFlowType, onClose, onSubmit, territories }) {
    const [editBackFlowType, setEditBackFlowType] = useState(backFlowType);
    useEffect(() => {
        if (backFlowType)
            setEditBackFlowType(backFlowType);
    }, [backFlowType]);
    const handleSubmitForm = () => __awaiter(this, void 0, void 0, function* () {
        if (editBackFlowType) {
            return onSubmit(editBackFlowType);
        }
        return false;
    });
    const handleNameChange = (event) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { displayName: event.target.value }));
        }
    };
    const handleActiveChange = (event) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { active: event.target.checked }));
        }
    };
    const handleTerritoryChange = (values) => {
        if (editBackFlowType) {
            setEditBackFlowType(Object.assign(Object.assign({}, editBackFlowType), { territoryIds: values }));
        }
    };
    return (React.createElement(Brushaway, { open: backFlowType !== null, title: translate('edit_title', { namespace }), isForm: true, onClose: () => {
            onClose();
        }, onSubmit: handleSubmitForm },
        React.createElement("div", null,
            React.createElement("div", { className: "formSection" },
                React.createElement(TextInput, { id: "name", value: editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.displayName, label: translate('name_label', { namespace }), onChange: handleNameChange }),
                territories.length > 0 && (React.createElement("div", { className: "mt-3" },
                    React.createElement(SelectInput, { label: translate('territories_label', { namespace }), options: territories, values: (editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.territoryIds) || [], onMultiChange: handleTerritoryChange, multiple: true, showSearch: true, displayMode: "labels", className: "mb-1" }),
                    React.createElement("small", { className: "note-section" },
                        React.createElement("i", { className: "fa fa-light fa-circle-info mr-1" }),
                        translate('territories_hint', { namespace })))),
                React.createElement("label", { className: "qmb-checkbox mt-3" },
                    React.createElement("input", { type: "checkbox", checked: editBackFlowType === null || editBackFlowType === void 0 ? void 0 : editBackFlowType.active, onChange: handleActiveChange }),
                    React.createElement("p", { className: "qmb-checkbox-label", style: { padding: 0 } },
                        React.createElement("span", { className: "qmb-checkbox-title" }, 'Active')))))));
}
export default BackFlowTypeDetail;
